import { cn } from "@/shared/lib/cn";

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Already-translated accessible label — shared/ui stays i18n-free. */
  label: string;
  className?: string;
}

/**
 * A monochrome on/off toggle (e.g. enable a skill). Mirrors the Cendre system:
 * an ink-filled track when on, a hairline track when off, with a paper knob.
 */
export function Switch({ checked, onChange, disabled, label, className }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        "relative inline-flex h-[22px] w-[38px] shrink-0 items-center rounded-full outline-none transition-colors duration-150 ease-house focus-visible:ring-[3px] focus-visible:ring-[var(--focus-ring)] disabled:pointer-events-none disabled:opacity-50",
        checked ? "bg-accent" : "bg-bubble",
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "pointer-events-none absolute size-[16px] rounded-full shadow-[0_1px_2px_rgba(0,0,0,0.2)] transition-[transform,background-color] duration-150 ease-house",
          checked ? "translate-x-[18px] bg-canvas" : "translate-x-[2px] bg-white dark:bg-ink-faint",
        )}
      />
    </button>
  );
}
